import $ from 'jquery'

const miFooter2 = () => {
    // Bind to the outer container for menu 2
    const $footerContainer = $('.mi-footer--menu-2');

    if (!$footerContainer.length) return;

    // Grid columns splitting for 4 columns: 3 | 3 | 5 | 2
    $footerContainer.each(function () {
        const $parent = $(this);
        const $navMain = $parent.find('.elementor-nav-menu--main');
        const $ul = $navMain.find('> ul.elementor-nav-menu');

        // Prevent double execution
        if (!$ul.length || $parent.find('.footer-bento-wrapper').length) return;

        const $items = $ul.children('li');

        // Get original classes to preserve Elementor styling
        const ulClass = $ul.attr('class') || 'elementor-nav-menu';

        // Group items into 4 separate lists (3 | 3 | 5 | 2) for the bento layout
        const $col1 = $(`<ul class="${ulClass} footer-bento-col footer-bento-col-1"></ul>`).append($items.slice(0, 3));
        const $col2 = $(`<ul class="${ulClass} footer-bento-col footer-bento-col-2"></ul>`).append($items.slice(3, 6));
        const $col3 = $(`<ul class="${ulClass} footer-bento-col footer-bento-col-3"></ul>`).append($items.slice(6, 11));
        const $col4 = $(`<ul class="${ulClass} footer-bento-col footer-bento-col-4"></ul>`).append($items.slice(11));

        // Create a wrapper div to contain the 4 columns
        const $wrapper = $('<div class="footer-bento-wrapper footer-bento-wrapper--4-col"></div>');
        $wrapper.append($col1, $col2, $col3, $col4);

        // Replace the original single UL with the new multi-column bento wrapper
        $ul.replaceWith($wrapper);
    });

    // Make all menus open on first render
    $footerContainer.find('.menu-item-has-children').addClass('is-active');

    // Disable SmartMenus completely on the footer to eliminate hover glitches
    setTimeout(() => {
        // Query the elements again inside the timeout in case layout was replaced
        const $footerMenu = $footerContainer.find('.elementor-nav-menu');

        if ($.fn.smartmenus) {
            $footerMenu.smartmenus('destroy');
        }

        // Remove inline styles if any were set previously
        $footerMenu.find('ul.sub-menu').removeAttr('style');
    }, 100);

    // Accordion click logic (pure CSS driven)
    // Delegate the event to the static container rather than the dynamic <ul>
    $footerContainer.on('click', '.menu-item-has-children > a', function (e) {
        const $target = $(e.target);
        const $parentLi = $(this).parent();
        const href = $(this).attr('href');
        const isDummyLink = !href || href === '#' || href.trim() === '' || href.startsWith('javascript:');

        // If the arrow button (.sub-arrow) is clicked, toggle expand/collapse
        if ($target.closest('.sub-arrow').length) {
            e.preventDefault();
            e.stopPropagation();
            $parentLi.toggleClass('is-active');
            return;
        }

        // If the link has no valid URL (e.g. '#'), toggle expand/collapse
        if (isDummyLink) {
            e.preventDefault();
            $parentLi.toggleClass('is-active');
        }
        // Valid page URLs navigate to the target page normally
    });
}

try {
    miFooter2();
} catch (error) {
    console.warn(error);
}
